import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
export const useApplicantAddressFieldBindings = options => {
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const {
    bindAddressField
  } = useBindApplication();
  const applicantAddress = bindAddressField(currentApplicantPath.value + "[personal-details][addresses]" + `[${options.addressIndex.value}]`);
  return {
    applicantAddress
  };
};